import { createSlice, createAsyncThunk, PayloadAction } from '@reduxjs/toolkit'
import axios from 'axios'
import { AnswerSet } from './viewmodels/AnswerSetViewModel'
import { Answer } from './viewmodels/AnswerViewModel'
import { Item } from './viewmodels/ItemViewModel'
import { ItemsetResult } from './viewmodels/ItemsetViewModel'


const initialState: AnswerSet = {
    answers: [] as Answer[],
    student: NaN,
    itemset: {} as ItemsetResult,
    start_time: '',
    end_time: '',
    new: false,
}

export const postAnswerSet = createAsyncThunk('postAnswerSet', async (_: void, thunkApi) => {
    const allStates: any = thunkApi.getState()
    const asState: AnswerSet = allStates.answerSet
    const URL: string = window.location.href.includes('localhost') ? 'http://localhost:8000/api/answersets/' : '/api/answersets/'
    await axios.post(URL, {
        answers: asState.answers,
        student: asState.student,
        itemset: asState.itemset.id,
        start_time: asState.start_time,
        end_time: asState.end_time,
    })
        .then((response) => {
            console.log(response)
        }, (error) => {
            console.log(error)
        })
})

export const postAnswerFile = createAsyncThunk('postAnswerFile', async ({ file, itemRef }: { file: File | undefined, itemRef: Item }, thunkApi) => {
    const allStates: any = thunkApi.getState()
    const asState: AnswerSet = allStates.answerSet
    const submitTime: Date = new Date()
    const form = new FormData()
    form.append('file', file!)
    form.append('student', asState.student.toString())
    form.append('itemset', asState.itemset.id.toString())
    form.append('submit_time', submitTime.toISOString())
    form.append('item', itemRef.id.toString())
    const URL: string = window.location.href.includes('localhost') ? 'http://localhost:8000/api/answerfiles/' : '/api/answerfiles/'
    await axios.post(URL, form, {
        headers: {
            'Content-Type': 'multipart/formdata',
        }
    })
        .then((response) => {
            console.log(response)
        }, (error) => {
            console.log(error)
        })
})

const answerSetSlice = createSlice({
    name: 'answerSet',
    initialState,
    reducers: {
        addAnswerToSet: (state, action: PayloadAction<Answer>) => {
            state.answers = state.answers.concat(action.payload)
        },
        addStudentId: (state, action: PayloadAction<number>) => {
            state.student = action.payload
        },
        addItemSet: (state, action: PayloadAction<ItemsetResult>) => {
            state.itemset = action.payload
        },
        setStartTime: (state, action: PayloadAction<string>) => {
            if (state.start_time === initialState.start_time) { state.start_time = action.payload }
        },
        setEndTime: (state, action: PayloadAction<string>) => {
            if (state.end_time === initialState.end_time) { state.end_time = action.payload }
        },
        newAsLoaded: (state) => {
            state.new = !state.new
        },
        resetAsSliceState: (state) => {
            state.answers = initialState.answers
            state.start_time = initialState.start_time
            state.end_time = initialState.end_time
            state.itemset = initialState.itemset
            state.student = initialState.student
            state.new = true
        }
    },
    extraReducers:
        (builder) => {
        }
})


export const {
    actions: { addAnswerToSet, addItemSet, addStudentId, setStartTime, setEndTime, resetAsSliceState, newAsLoaded },
} = answerSetSlice;

export default answerSetSlice.reducer